import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';


interface RouterState {
  loading: boolean;
  loadingError: boolean;
  route: any;
}



const initialState: RouterState = {
  loading: false,
  loadingError: false,
  route: null,
};

const routerSlice = createSlice({
  name: 'router',
  initialState,
  reducers: {
    fetchRoute(state: RouterState, action : PayloadAction<{}> ) {
      state.loading = true;
      state.loadingError = false;

    },
    fetchRouteSuccess(state: RouterState, action: PayloadAction<{}>) {
      state.route = action.payload;
      state.loading = false;
    },
    fetchRouteFailed(state: RouterState) {
      state.loading = false;
      state.loadingError = true;
    },
  },
});

// Actions
export const routerActions = routerSlice.actions;
// Selectors
export const routeLoading = (state: { router: RouterState }): boolean => state.router.loading;
export const routeLoadingError = (state: { router: RouterState }): boolean => state.router.loadingError;
export const selectRoute = (state: { router: RouterState }): any => state.router.route;

// Reducers
const routerReducer = routerSlice.reducer;
export default routerReducer;